var exports = {
  "Q": "x1cb7f6e3--30230c--text",
  "D": "x1cb7f6e3--30230c--title",
};

module.exports = exports;
